<template>
  <div class="bulk-action-selector">
    <div class="mr-4">
      <label class="block text-sm font-medium leading-5 text-gray-700">Bulk Actions</label>
      <div class="mt-1 relative rounded-md shadow-sm">
        <multiselect class="multiselector"
          v-model="selectedAction"
          :options="actionOptions"
          label="name"
          track-by="value"
          placeholder=""
          :clear-on-select="true"
          :show-labels="false"
          :multiple="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import ModalService from '@services/ModalService'
  import BulkActionService from '@services/BulkActionService'

  export default {
    name: 'bulk-action-selector',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedAction: null,
        actionOptions: BulkActionService.getAvailableActions(this.bulkActionModel, window.gon.current_user.roles),
      }
    },
    computed: {
      domSelector () {
        return `input[type="checkbox"][data-bulk-action-model="${this.bulkActionModel}"]`
      },
    },
    methods: {
      openModal (opts) {
        ModalService.spawn('bulk-action-modal', {
          ...opts,
          resultCb: () => {
            this.uncheckAll()
          },
        })
      },
      gatherSelectedRecords () {
        const cbxs = document.querySelectorAll(`${this.domSelector}:not(.select-all)`)
        const ids = []
        cbxs.forEach(el => {
          if (el.checked) {
            ids.push(el.value)
          }
        })
        return ids
      },
      uncheckAll () {
        const cbxs = document.querySelectorAll(this.domSelector)
        cbxs.forEach(el => {
          el.checked = false
        })
      },
    },
    props: {
      bulkActionModel: {
        type: String,
        required: true,
      },
      bulkActionFilter: {
        type: String,
        required: false,
      },
      bulkActionOptions: {
        type: String,
        required: false,
      }
    },
    watch: {
      selectedAction (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          const baOptions = this.bulkActionOptions ? JSON.parse(this.bulkActionOptions) : {};
          baOptions['modalType'] = newVal.modalType || null
          this.openModal({
            bulkAction: newVal.value,
            bulkActionModel: this.bulkActionModel,
            bulkActionFilter: this.bulkActionFilter ? this.bulkActionFilter : '',
            bulkActionOptions: baOptions,
            ids: this.gatherSelectedRecords(),
          })
          this.selectedAction = null
        }
      },
    },
  }
</script>

<style lang="scss">
  .multiselector {
    min-width: 14rem;
    max-width: 14rem;
  }
</style>
